var exports = {
  "Gn": "spriteAnimation__9Q7nWI",
  "JP": "copilotScaleAnimation__1LGGh2",
  "e8": "blink-star__eEzThh",
  "Gf": "trail-animation-1__4WeIxQ",
  "NT": "trail-animation-2__XEVIP0",
  "Uv": "trail-animation-3__jrjD45",
  "Nc": "trail-animation-4__VyLQi8",
  "G$": "trail-animation-5__DoydBF",
  "NN": "trail-animation-6__Aib6Ni",
  "Gu": "trail-animation-7__qdYJJn",
  "N8": "trail-animation-8__l46fAo",
  "UK": "trail-animation-9__Wz8CJQ",
  "G3": "trail-animation-10__uxA59h",
  "WG": "sparkle-animation-1__-4Nlb-",
  "PJ": "sparkle-animation-2__UAa-CD",
  "Wl": "sparkle-animation-3__pYb11w",
  "Bt": "sparkle-animation-4__M4kqEZ",
  "I7": "sparkle-animation-5__E8Y57X",
  "PP": "sparkle-animation-6__MbsTh2",
  "Wr": "sparkle-animation-7__bun2rf",
  "Pu": "sparkle-animation-8__9c4Xvn",
  "Ib": "sparkle-animation-9__CsrVkk",
  "M3": "sparkle-animation-10__7hmvBg",
  "Yf": "activate__QmzPj7",
  "vo": "copilot__qvG-9o",
  "_7": "sparkles__uaK2pD",
  "dQ": "sparkle__c1kosT",
  "fU": "sparkleTrail__vjEHOn",
};

module.exports = exports;
